/* eslint-disable react/react-in-jsx-scope */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';

import Rotation from './rotation';

import { RuleLayers } from './styled';

import { type SchedulesProps } from '../../../common/types';
import { localMidnight } from '../../../common/utils';

export function Schedules({ startDate, timezone, days, rotations }: SchedulesProps) {
	const localStartDate = localMidnight(startDate, timezone);

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		<RuleLayers className="rule-layers">
			{rotations.map(({ name, periods }) => (
				<Rotation
					startDate={localStartDate}
					{...{
						days,
						timezone,
						name,
						periods,
					}}
					key={name}
				/>
			))}
		</RuleLayers>
	);
}

export default Schedules;
